import { Field } from '@yes.technology/react-toolkit'
import { useMemo } from 'react'
import { RelationConfigProps } from '../../types/object-view'

type UseRelationClassesProps = {
  relationFields?: Field[]
  relationConfig?: RelationConfigProps
}

const useRelationClasses = ({
  relationFields,
  relationConfig
}: UseRelationClassesProps) => {
  return useMemo(() => {
    const relations = relationFields ?? []
    if (
      typeof relationConfig === 'object' &&
      Object.keys(relationConfig).length > 0
    ) {
      const relationsWithDefinedConfig = Object.keys(relationConfig)

      return relations.filter((relation) =>
        relationsWithDefinedConfig.includes(relation?.uuid)
      )
    }

    return relations
  }, [relationFields, relationConfig])
}

export default useRelationClasses
